import { createColumnsOfDropdown } from './link_column_creator';

const DesktopNavbarItemType = {
  LINK: 'link',
  IMAGE_AND_LINK_GROUP_HOVERABLE_MENU: 'image-and-link-groups-hoverable-menu'
};

const normalizeDesktopNavbarItems = (desktopNavbarItems, maxNumberOfRows) => {
  const normalized = [];
  for (let i = 0; i < desktopNavbarItems.length; ++i) {
    const normalizedHighlightRoutes = [];
    for (let j = 0; j < desktopNavbarItems[i].highlight_routes.length; ++j) {
      normalizedHighlightRoutes.push({
        key: desktopNavbarItems[i].highlight_routes[j].key,
        siteRoute: desktopNavbarItems[i].highlight_routes[j].site_route
      });
    }
    const commonFields = {
      key: desktopNavbarItems[i].key,
      type: desktopNavbarItems[i].type,
      title: desktopNavbarItems[i].title,
      to: desktopNavbarItems[i].to,
      highlightRoutes: normalizedHighlightRoutes
    };
    if (desktopNavbarItems[i].type === DesktopNavbarItemType.LINK) {
      normalized.push({
        ...commonFields,
        data: {}
      });
    } else if (desktopNavbarItems[i].type === DesktopNavbarItemType.IMAGE_AND_LINK_GROUP_HOVERABLE_MENU) {
      normalized.push({
        ...commonFields,
        data: {
          image: {
            route: desktopNavbarItems[i].hoverable_menu_info.image_route,
            alt: desktopNavbarItems[i].hoverable_menu_info.image_alt
          },
          imageSpecs: {
            translucentOverlayColor: desktopNavbarItems[i].hoverable_menu_info.translucent_overlay_color,
            imageOverlayText: desktopNavbarItems[i].hoverable_menu_info.image_overlay_text,
            imageOverlayTextColor: desktopNavbarItems[i].hoverable_menu_info.image_overlay_text_color
          },
          columns: createColumnsOfDropdown(desktopNavbarItems[i].hoverable_menu_info.link_groups, maxNumberOfRows, 'link-column')
        }
      });
    }
  }
  return normalized;
};

const mapMenuObjects = (menuObject, maxNumberOfRows) => {
  Object.keys(menuObject).forEach((key, index) => {
    menuObject[key] = normalizeDesktopNavbarItems(menuObject[key], maxNumberOfRows);
  });
  return menuObject;
};

const lemonadeGlobalThemeData = (themeData) => {
  const themeDataCopy = JSON.parse(JSON.stringify(themeData));
  return {
    navbarLogo: themeDataCopy.navbar_logo,
    footerLogo: themeDataCopy.footer_logo,
    invoiceLogo: themeDataCopy.invoice_logo,
    fixedNavbar: {
      generalInfo: {
        featuredMenSlugs: themeDataCopy.fixed_navbar.general_info.featured_men_slugs,
        featuredWomenSlugs: themeDataCopy.fixed_navbar.general_info.featured_women_slugs,
        featuredKidsSlugs: themeDataCopy.fixed_navbar.general_info.featured_kids_slugs
      },
      desktop: {
        bottomMenu: mapMenuObjects(
          themeDataCopy.fixed_navbar.desktop.bottom_menu,
          themeDataCopy.fixed_navbar.desktop.max_number_of_rows)
      },
      mobile: {
        preferredTabKey: themeDataCopy.fixed_navbar.mobile.preferred_tab_key,
        tabs: themeDataCopy.fixed_navbar.mobile.tabs
      }
    },
    siteFooter: {
      background: themeDataCopy.site_footer.background,
      copyrightNoticeBackground: themeDataCopy.site_footer.copyright_notice_background,
      subscribeSectionText: themeDataCopy.site_footer.subscribe_section_text,
      subscribeSectionTitle: themeDataCopy.site_footer.subscribe_section_title,
      socialMediaIcons: themeDataCopy.site_footer.social_media_icons,
      usefulLinks1: themeDataCopy.site_footer.useful_links1,
      usefulLinks2: themeDataCopy.site_footer.useful_links2,
      copyrightStatement: themeDataCopy.site_footer.copyright_statement
    },
    paymentLogos: {
      paymentIcons: themeDataCopy.payment_logos.payment_icons
    }
  };
};

export default lemonadeGlobalThemeData;
